/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";
export const GET_TOTAL_E_DOCUMENT = "GET_TOTAL_E_DOCUMENT";
export const GET_TOTAL_E_DOCUMENT_SUCCESS = "GET_TOTAL_E_DOCUMENT_SUCCESS";
export const GET_TOTAL_E_DOCUMENT_FAIL = "GET_TOTAL_E_DOCUMENT_FAIL";
export const GET_DONUT_CHART = "GET_DONUT_CHART";
export const GET_DONUT_CHART_SUCCESS = "GET_DONUT_CHART_SUCCESS";
export const GET_DONUT_CHART_FAIL = "GET_DONUT_CHART_FAIL";
export const GET_TOTAL_NOTIFICATION = "GET_TOTAL_NOTIFICATION";
export const GET_TOTAL_NOTIFICATION_SUCCESS = "GET_TOTAL_NOTIFICATION_SUCCESS";
export const GET_TOTAL_NOTIFICATION_FAIL = "GET_TOTAL_NOTIFICATION_FAIL";
export const GET_STACKED_DATA = "GET_STACKED_DATA";
export const GET_STACKED_DATA_SUCCESS = "GET_STACKED_DATA_SUCCESS";
export const GET_STACKED_DATA_FAIL = "GET_STACKED_DATA_FAIL"